import { render, staticRenderFns } from "./quotation-overview.vue?vue&type=template&id=acd0e9e6"
import script from "./quotation-overview.vue?vue&type=script&lang=js"
export * from "./quotation-overview.vue?vue&type=script&lang=js"
import style0 from "./quotation-overview.vue?vue&type=style&index=0&id=acd0e9e6&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('acd0e9e6')) {
      api.createRecord('acd0e9e6', component.options)
    } else {
      api.reload('acd0e9e6', component.options)
    }
    module.hot.accept("./quotation-overview.vue?vue&type=template&id=acd0e9e6", function () {
      api.rerender('acd0e9e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/quotation-overview.vue"
export default component.exports